import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const NewReceiptWrapper = styled.section`
  height: 486px;
  padding: ${Spacing.S24};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
`
